export const SEND_PAYMENT_RESPONSE = 'SEND_PAYMENT_RESPONSE';
